"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("intl");
require("intl/locale-data/jsonp/en");
require("@formatjs/intl-datetimeformat/polyfill");
require("@formatjs/intl-getcanonicallocales/polyfill");
require("@formatjs/intl-locale/polyfill");
require("@formatjs/intl-numberformat/polyfill");
require("@formatjs/intl-pluralrules/polyfill");
require("@formatjs/intl-relativetimeformat/polyfill");
require("@formatjs/intl-datetimeformat/add-all-tz");
require("@formatjs/intl-datetimeformat/locale-data/en");
require("@formatjs/intl-numberformat/locale-data/en");
require("@formatjs/intl-pluralrules/locale-data/en");
require("@formatjs/intl-relativetimeformat/locale-data/en");
var _intl2 = require("@formatjs/intl");
var _callbacks = _interopRequireDefault(require("../callbacks"));
var _logger = _interopRequireDefault(require("./logger"));
var _excluded = ["defaultMessage", "description"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; } // inject Intl not provided for android
// inject polyfill
// add default locale
// to avoid react-intl error => formattime unmatched parentheses
if (Intl.__disableRegExpRestore) Intl.__disableRegExpRestore();
var logger = new _logger.default('i18n');
var _defaultLanguageTag = /*#__PURE__*/new WeakMap();
var _currentLanguageTag = /*#__PURE__*/new WeakMap();
var _currentLanguageIsRTL = /*#__PURE__*/new WeakMap();
var _intlInstance = /*#__PURE__*/new WeakMap();
class Locale {
  constructor() {
    var _this = this;
    _classPrivateFieldInitSpec(this, _defaultLanguageTag, {
      writable: true,
      value: 'en'
    });
    _classPrivateFieldInitSpec(this, _currentLanguageTag, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _currentLanguageIsRTL, {
      writable: true,
      value: false
    });
    _classPrivateFieldInitSpec(this, _intlInstance, {
      writable: true,
      value: null
    });
    _defineProperty(this, "translationGetters", {
      en: () => {
        var local = require("../i18n/en.json");
        var client = _callbacks.default.get('i18n/en')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      fr: () => {
        require('intl/locale-data/jsonp/fr');
        require('@formatjs/intl-pluralrules/locale-data/fr');
        require('@formatjs/intl-relativetimeformat/locale-data/fr');
        require('@formatjs/intl-datetimeformat/locale-data/fr');
        var local = require("../i18n/fr.json");
        var client = _callbacks.default.get('i18n/fr')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      de: () => {
        require('intl/locale-data/jsonp/de');
        require('@formatjs/intl-pluralrules/locale-data/de');
        require('@formatjs/intl-relativetimeformat/locale-data/de');
        require('@formatjs/intl-datetimeformat/locale-data/de');
        var local = require("../i18n/de.json");
        var client = _callbacks.default.get('i18n/de')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      es: () => {
        require('intl/locale-data/jsonp/es');
        require('@formatjs/intl-pluralrules/locale-data/es');
        require('@formatjs/intl-relativetimeformat/locale-data/es');
        require('@formatjs/intl-datetimeformat/locale-data/es');
        var local = require("../i18n/es.json");
        var client = _callbacks.default.get('i18n/es')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      ru: () => {
        require('intl/locale-data/jsonp/ru');
        require('@formatjs/intl-pluralrules/locale-data/ru');
        require('@formatjs/intl-relativetimeformat/locale-data/ru');
        require('@formatjs/intl-datetimeformat/locale-data/ru');
        var local = require("../i18n/ru.json");
        var client = _callbacks.default.get('i18n/ru')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      vi: () => {
        require('intl/locale-data/jsonp/vi');
        require('@formatjs/intl-pluralrules/locale-data/vi');
        require('@formatjs/intl-relativetimeformat/locale-data/vi');
        require('@formatjs/intl-datetimeformat/locale-data/vi');
        var local = require("../i18n/vi.json");
        var client = _callbacks.default.get('i18n/vi')();
        return _objectSpread(_objectSpread({}, local), client);
      },
      th: () => {
        require('intl/locale-data/jsonp/th');
        require('@formatjs/intl-pluralrules/locale-data/th');
        require('@formatjs/intl-relativetimeformat/locale-data/th');
        require('@formatjs/intl-datetimeformat/locale-data/th');
        var local = require("../i18n/th.json");
        var client = _callbacks.default.get('i18n/th')();
        return _objectSpread(_objectSpread({}, local), client);
      }
    });
    _defineProperty(this, "translate", function (id) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        {
          defaultMessage = id,
          description
        } = _ref,
        options = _objectWithoutProperties(_ref, _excluded);
      if (!_classPrivateFieldGet(_this, _intlInstance)) {
        logger.log('translate error no #intlInstance ', {
          id,
          defaultMessage,
          description,
          options
        });
        return '';
      }
      return _classPrivateFieldGet(_this, _intlInstance).formatMessage({
        id,
        defaultMessage,
        description
      }, _objectSpread({}, options));
    });
    _defineProperty(this, "formatMessage", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_classPrivateFieldGet(_this, _intlInstance)) {
        logger.log('formatMessage error no #intlInstance ', _objectSpread({}, args));
        return '';
      }
      return _classPrivateFieldGet(_this, _intlInstance).formatMessage(...args);
    });
    _defineProperty(this, "formatDate", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (!_classPrivateFieldGet(_this, _intlInstance)) {
        logger.log('formatDate error no #intlInstance ', _objectSpread({}, args));
        return '';
      }
      return _classPrivateFieldGet(_this, _intlInstance).formatDate(...args);
    });
    _defineProperty(this, "formatRelativeAuto", date => {
      var delta = Math.round((Date.now() - new Date(date).getTime()) / 1000);
      if (!_classPrivateFieldGet(this, _intlInstance)) {
        logger.log('formatRelativeAuto error no #intlInstance ', {
          date
        });
        return '';
      }
      var ONE_MINUTE = 60;
      var ONE_HOUR = 60 * ONE_MINUTE;
      var ONE_DAY = 24 * ONE_HOUR;
      var MAX_DAY = 7 * ONE_DAY;
      if (delta === 0) {
        return this.formatRelativeTime(delta, 'second', {
          numeric: 'auto'
        });
      } else if (delta < ONE_MINUTE) {
        return this.formatRelativeTime(-1 * delta, 'second');
      } else if (delta < ONE_HOUR) {
        return this.formatRelativeTime(Math.round(-1 * delta / ONE_MINUTE), 'minute');
      } else if (delta < ONE_DAY) {
        return this.formatRelativeTime(Math.round(-1 * delta / ONE_HOUR), 'hour');
      } else if (delta < MAX_DAY) {
        return this.formatRelativeTime(Math.round(-1 * delta / ONE_DAY), 'day', {
          numeric: 'auto'
        });
      } else {
        return this.formatDate(date);
      }
    });
    _defineProperty(this, "formatRelativeTime", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (!_classPrivateFieldGet(_this, _intlInstance)) {
        logger.log('formatRelative error no #intlInstance ', _objectSpread({}, args));
        return '';
      }
      return _classPrivateFieldGet(_this, _intlInstance).formatRelativeTime(...args);
    });
    _defineProperty(this, "formatTime", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      if (!_classPrivateFieldGet(_this, _intlInstance)) {
        logger.log('formatTime error no #intlInstance ', _objectSpread({}, args));
        return '';
      }
      return _classPrivateFieldGet(_this, _intlInstance).formatTime(...args);
    });
    _defineProperty(this, "findBestAvailableLanguage", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (languageTag) {
        logger.info('findBestAvailableLanguage', languageTag);
        if (languageTag) {
          // set the lang for this profile
          _callbacks.default.get('asyncStorageSetItem')('locales:tag', languageTag);
          return {
            languageTag,
            isRTL: false
          };
        } else {
          // try to get the previous lang setting
          var tag = yield _callbacks.default.get('asyncStorageGetItem')('locales:tag');
          if (tag) return {
            languageTag: tag,
            isRTL: false
          };
        }
        // search the best lang based on the langs installed on the device
        var fallback = {
          languageTag: _classPrivateFieldGet(_this, _defaultLanguageTag),
          isRTL: false
        };
        var langList = Object.keys(_this.translationGetters);
        if (!_callbacks.default.isExist('findBestAvailableLanguage')) return fallback;
        return _callbacks.default.get('findBestAvailableLanguage')(langList) || fallback;
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setI18nConfig", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (langSelected) {
        logger.info('setI18nConfig', langSelected);
        var {
          languageTag,
          isRTL
        } = yield _this.findBestAvailableLanguage(langSelected);
        if (_classPrivateFieldGet(_this, _currentLanguageTag) === languageTag || !_this.translationGetters[languageTag]) return;
        _classPrivateFieldSet(_this, _currentLanguageTag, languageTag);
        _classPrivateFieldSet(_this, _currentLanguageIsRTL, isRTL);
        _callbacks.default.get('i18nForceRTL')(isRTL);
        var timeZone;
        if (_callbacks.default.isExist('getTimeZone')) {
          timeZone = _callbacks.default.get('getTimeZone', false)();
        }
        var cache = (0, _intl2.createIntlCache)();
        _classPrivateFieldSet(_this, _intlInstance, (0, _intl2.createIntl)({
          locale: languageTag,
          timeZone,
          messages: _this.translationGetters[languageTag](),
          onError: e => logger.log(e)
        }, cache));
        if (_callbacks.default.isExist('setLang')) {
          _callbacks.default.get('dispatch')(_callbacks.default.get('setLang')(languageTag));
        }
      });
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.setI18nConfig();
  }
}
var _default = exports.default = new Locale();
module.exports = exports.default;